'use strict';

export enum LanguageCode {
  SiteDefault = 'site-default',
  English = 'en',
  Spanish = 'es',
}
